import styled from "styled-components";

export const ExportCsvModalStyled = styled.div`
  height: 340px;
  width: 500px;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  border-radius: 6px;
  border: 1px solid var(--flow-30-neutral-2, #dedafb);
  background: var(--flow-30-neutral-white, #fff);
  position: relative;

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 7px;
    flex: 1 0 0;
    padding-bottom: 16px;
  }

  .fields {
    display: grid;
    gap: 16px;
  }

  .ant-picker{
    width: 100%;
  }
  .btn-wrap {
    position: absolute;
    bottom: 16px; /* Position the buttons at the bottom */
    left: 16px;
    right: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    padding-top: 16px;
    background: var(--flow-30-neutral-white, #fff);
  }
  button {
    width: 110px;
  }

  .cancel-btn {
    background-color: #efedfd;
    &:hover {
      background-color: #d5bdef;
    }
  }
`;
